export const API_BASE_URL = "https://api.unity.net.my/";
export const API_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0eXBlIjoiZnJvbnRlbmQiLCJjdXN0b21lcl9pZCI6IjMiLCJ1c2VyX25hbWUiOiJhYmMxMjMiLCJ1c2VyX2VtYWlsIjoia2V2aW5rYXVtbEB5YWhvby5jb20iLCJ2YWxpZGF0aW9uIjoiYTJWMmFXNXJZWFZ0YkVCNVlXaHZieTVqYjIxOGZGUmxjM1FnUTBKRWZIeG1NalprWmpZM1pUZ3hNVEJsWlRKaU5EUTVNak5rWWpjM05XVXpaVFEzWmc9PSIsInRlcm1faWQiOiIiLCJleHAiOjE3NTM1MDQ4MzYsInByb2ZpbGVfcGhvdG9fdXJsIjoiaHR0cHM6XC9cL3VhdGZpbGUudW5pdHkubmV0Lm15XC9pbWFnZXNcL3VwbG9hZHNcL2N1c3RvbWVyX3Byb2ZpbGVfcGljXC8zXC9wcm9maWxlX2ltZ182ODRmYzM5ODQyNjEzLmpwZWciLCJzYWxlc21hbl9pZCI6IiIsIm1haW5faWQiOiIzIn0.5dSe5ivutQ4NigHBH9oKUdsvshqMP_qNnpW2MFJ28Ls";
export const STAFF_PURCHASE_ID = "2299";
export const REDIRECT_LOGIN_URL = "https://login.unity.net.my/login?redirect=unity_home";
export const REDIRECT_SWITCH_USER_URL = "https://login.unity.net.my/login?redirect=customer_dashboard";
export const BACKEND_URL = "https://backend.unity.net.my/";
export const MYINVOICE_URL = "https://customer.unity.net.my/myinvoice";
export const BRAND = "";
export const VERSION = '2';

// When 1: enable region selection popup and pass selected region to item/bundle/package APIs
// When 0: disable popup and do not pass region
export const SHOW_REGION_POPUP = 1;

export const ACCESS_KEYS = {
  HOME: "home",
  MY_PROFILE: "my_profile",
  MY_ORDER: "my_order",
  MY_REPAIR: "my_repair",
  MY_INVOICE: "my_invoice",
  MY_PAYMENT: "my_payment",
  MY_CN: "my_cn",
  MY_DN: "my_dn",
  MY_CONTRA: "my_contra",
  MY_RF: "my_rf",
  DOCUMENT: "my_document",
};

export const CASH_ACCOUNT = 'CASH';